import { AppThunk } from '../../../../../store/types';
import { PhraseListActions } from '../../../../../store/phrase-list/actions';
import { PhraseDetailsSelectors } from '../../../../../store/phrase-details/selectors';
import { Navigator } from '../../../../../effects/navigator';
import { PhraseListSelectors } from '../../../../../store/phrase-list/selectors';
import { getGroupNativeLanguage, getGroupTargetLanguage, getUserGroupById } from '../../../../../store/models/selectors';
import { PhraseDetailsEffects } from '../../../../../effects/phrase-details/phrase-details-effects';
import { EVocabularyPhraseType } from '../../../../../types/common';
import { PhraseEffects } from '../../../../../effects/phrase/PhraseEffects';
import { EPhrasePopupType } from '../../../../../store/phrase-list/types';

export class PhraseNotesPreviewEvents {

	public static onEdit(): AppThunk {
		return (
			dispatch,
			getState
		) => {
			const state = getState();
			const phraseId = PhraseDetailsSelectors.getPhraseId(state);
			if (!phraseId) return;

			dispatch(PhraseListActions.setForwardPhraseId(phraseId));			
			const phrase = PhraseListSelectors.findPhraseById(state, phraseId);
			if (!phrase?.userGroupId) return;
			const group = getUserGroupById(state, phrase.userGroupId);
			if (!group) return;
			const targetLang = getGroupTargetLanguage(state, group);
			if (!targetLang) return;
			const nativeLang = getGroupNativeLanguage(state, group);
			PhraseDetailsEffects.showFromSavedPhrase(targetLang, nativeLang, nativeLang, phrase.highlighted, phrase, EPhrasePopupType.CAPTIONS);
			// dispatch(CaptionsSelectionPopupActions.setCurrentSelection({wordPhraseId: phrase.wordPhraseId, contextPhraseId: phrase.id}));
			// dispatch(PhraseListActions.setPlayCaptionByPhraseId(phrase.id));
			
			PhraseEffects.seekPhrase(phrase);
			dispatch(PhraseListActions.setPhrasePopup(EPhrasePopupType.SAVED));
			dispatch(PhraseListActions.setNotePopup(true));
		}
	}

	public static onClickAuthor(): AppThunk {
		return (
		  dispatch,
		  getState
		) => {
			const note = PhraseDetailsSelectors.getCurrentNote(getState());
			const userName = note?.authorInfo?.userName;
			if (userName) {
				Navigator.openPublicProfile(userName);
			}
		}
	}

}